// extracted by mini-css-extract-plugin
export var editButton = "_ks-0";